// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------

// --------- header clock -------------

function updateIndianTime() {
  const options = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const indianTime = new Date().toLocaleTimeString("en-IN", options);
  const timeElements = document.getElementsByClassName("ind-time");

  Array.from(timeElements).forEach((element) => {
    element.innerHTML = `INDIA &nbsp;&nbsp;&nbsp; ${indianTime}`;
  });
}
updateIndianTime();
setInterval(updateIndianTime, 1000);
// --------- header clock -------------

//---------------- Header cart total update--------------------------
// Select the element that displays the cart total
function formatINR(amount) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(amount / 100);
}
let lastCartTotal = null;
document.addEventListener("DOMContentLoaded", () => {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    if (
      args[0].includes("/cart") ||
      args[0].includes("/add") ||
      args[0].includes("/change") ||
      args[0].includes("/update")
    ) {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          if (cart.total_price !== lastCartTotal) {
            lastCartTotal = cart.total_price;
            document.querySelector(
              ".header-cart-total"
            ).innerText = `RS. ${formatINR(lastCartTotal)}`;
          }
        });
    }

    return response;
  };
});
//---------------- Header cart total update END--------------------------

// ================= Menu Drawer ===================

const menuBtn = document.querySelector(".top-right-four .m-menu");
const menuCont = document.querySelector(".menu-cont");

menuBtn.addEventListener("click", () => {
  menuCont.classList.toggle("active");
});

function closeMenu() {
  menuCont.classList.remove("active");
}

// ================= Menu Drawer ===================

// --------------------Draggable Scroll --------------------------------

function initDragToScroll(container) {
  if (!container) return;
  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;
  let currentX = 0;
  let rafId = null;
  let hasDragged = false;
  const dragThreshold = 5;

  // Prevent images from being dragged
  container.querySelectorAll("img").forEach((img) => {
    img.setAttribute("draggable", "false");
  });

  // Disable or enable anchor interactions and text selection
  const toggleAnchors = (disable) => {
    container.querySelectorAll("a").forEach((anchor) => {
      anchor.style.pointerEvents = disable ? "none" : "";
      anchor.style.userSelect = disable ? "none" : "";
    });
  };

  // Toggle text selection on the container itself
  const toggleContainerSelection = (disable) => {
    container.style.userSelect = disable ? "none" : "";
  };

  // Smoothly update scroll position while dragging
  const smoothScroll = () => {
    if (!isDragging) return;

    const distance = currentX - startX;

    if (Math.abs(distance) > dragThreshold && !hasDragged) {
      hasDragged = true;
      toggleAnchors(true);
      toggleContainerSelection(true);
    }

    container.scrollLeft = scrollLeft - distance;
    rafId = requestAnimationFrame(smoothScroll);
  };

  const startDragging = (e) => {
        const target = e.target;
        if (target.closest("input, textarea, select, button ,.confirm-btn,p,h1,h2,span")) return; // Skip form elements
    isDragging = true;
    hasDragged = false;
    startX = e.pageX;
    currentX = startX;
    scrollLeft = container.scrollLeft;

    e.preventDefault(); // Prevent text selection
    container.classList.add("dragging");

    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(smoothScroll);
  };

  const stopDragging = () => {
    isDragging = false;
    container.classList.remove("dragging");
    cancelAnimationFrame(rafId);

    // Re-enable interactions after drag ends
    setTimeout(() => {
      toggleAnchors(false);
      toggleContainerSelection(false);
      hasDragged = false;
    }, 0);
  };

  // Event listeners
  container.addEventListener("mousedown", startDragging);
  container.addEventListener("mousemove", (e) => {
    if (isDragging) {
      currentX = e.pageX;
    }
  });
  container.addEventListener("mouseup", stopDragging);
  container.addEventListener("mouseleave", stopDragging);

  // Prevent link clicks if dragged
  container.addEventListener("click", (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
}

// Initialize drag-to-scroll on all sliders
document.addEventListener("DOMContentLoaded", () => {
  // Custome Scroll
  // initDragToScroll(document.querySelector('.sect6-flex-container'));
  // initDragToScroll(document.querySelector('product__media-list'));

  // Shopify Product Scroll Use This
  const sliders = document.querySelectorAll(".grid");
  sliders.forEach((slider) => initDragToScroll(slider));
});

// --------------------Draggable Scroll --------------------------------

// --------------------Footer Accordian --------------------------------

// accordion code start
// accordion code start

     (function() {
    const initializeAccordion = () => {
        const accordionItemHeaders = document.querySelectorAll(".f-navlist p");
        accordionItemHeaders.forEach(header => {
            header.removeEventListener("click", toggleAccordion);
        });

        accordionItemHeaders.forEach((accordionItemHeader) => {
            accordionItemHeader.addEventListener("click", toggleAccordion);
        });
    };

    const toggleAccordion = (event) => {
        const accordionItemHeader = event.currentTarget;
        const currentlyActiveAccordionItemHeader = document.querySelector(".f-navlist p.active");

        if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
            currentlyActiveAccordionItemHeader.classList.remove("active");
            currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }
        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
            accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
        } else {
            accordionItemBody.style.maxHeight = 0;
        }
    };
    initializeAccordion();
})();

// accordion code end

// accordion code end

// --------------------Footer Accordian --------------------------------

// --------------------Menu Accordian --------------------------------


// product accordion start
(function() {
    const initializeAccordion = () => {
        const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

        // Remove previous event listeners to prevent stacking
        accordionItemHeaders.forEach(header => {
            header.removeEventListener("click", toggleAccordion);
        });

        if (accordionItemHeaders.length > 0) {
            accordionItemHeaders.forEach((accordionItemHeader) => {
                accordionItemHeader.addEventListener("click", toggleAccordion);
            });
        }
    };

    const toggleAccordion = (event) => {
        const accordionItemHeader = event.currentTarget;
        const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");

        if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
            currentlyActiveAccordionItemHeader.classList.remove("active");
            currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }

        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
            accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px"; // Set max-height to scroll height
        } else {
            accordionItemBody.style.maxHeight = 0;
        }
    };

    // Call the function to initialize the accordion
    initializeAccordion();
})();


// --------------------Menu Accordian --------------------------------
